import { c as _c } from "react/compiler-runtime";
import { createPortal } from 'react-dom';

// Viewport-coordinate box rect + corner radius to morph between.
export type MorphRect = {
  top: number;
  left: number;
  width: number;
  height: number;
  radius: number;
};
export const MORPH_DURATION_MS = 220;
// A deliberate on-screen move, so a curve that holds at both ends rather than the built-in.
const MORPH_EASE = 'cubic-bezier(0.77, 0, 0.175, 1)';
type ChatWidgetMorphLayerProps = {
  rect: MorphRect;
  // Chrome shown inside the box (header etc.) — no live chat.
  children: React.ReactNode;
  // At the destination: fade out over `settleMs`, then call onFaded.
  settling: boolean;
  settleMs: number;
  onArrived: () => void;
  onFaded: () => void;
};

// Transient fixed box that morphs between two rects while the real chat is hidden.
// Chrome-only: never mounts the live ChatExperience, so no double websocket.
const ChatWidgetMorphLayer = t0 => {
  const $ = _c(17);
  const {
    rect,
    children,
    settling,
    settleMs,
    onArrived,
    onFaded
  } = t0;
  if (typeof document === "undefined") {
    return null;
  }
  const t1 = settling ? 0 : 1;
  const t2 = settling ? "opacity" : "top, left, width, height, border-radius";
  const t3 = `${settling ? settleMs : MORPH_DURATION_MS}ms`;
  const t4 = settling ? "ease-out" : MORPH_EASE;
  let t5;
  if ($[0] !== rect.height || $[1] !== rect.left || $[2] !== rect.radius || $[3] !== rect.top || $[4] !== rect.width || $[5] !== t1 || $[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height,
      borderRadius: rect.radius,
      opacity: t1,
      transitionProperty: t2,
      transitionDuration: t3,
      transitionTimingFunction: t4
    };
    $[0] = rect.height;
    $[1] = rect.left;
    $[2] = rect.radius;
    $[3] = rect.top;
    $[4] = rect.width;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onArrived || $[11] !== onFaded) {
    t6 = e => {
      if (e.target !== e.currentTarget) {
        return;
      }
      if (e.propertyName === "opacity") {
        onFaded();
      } else {
        if (e.propertyName === "width" || e.propertyName === "height") {
          onArrived();
        }
      }
    };
    $[10] = onArrived;
    $[11] = onFaded;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== children || $[14] !== t5 || $[15] !== t6) {
    t7 = createPortal(<div aria-hidden={true} className="fixed z-40 flex flex-col bg-primary border border-tertiary shadow-lg overflow-hidden pointer-events-none ease-in-out" style={t5} onTransitionEnd={t6}>{children}</div>, document.body);
    $[13] = children;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default ChatWidgetMorphLayer;